import './App.css';
import Weatherwebsite from './components/weather/weatherwebsite';

function App() {
  return (
    <>
      <Weatherwebsite/>
    </>
  );
  }

export default App;
